<template>
  <div class="box">
    <div class="main">
      <div class="information">
        当前就诊人：*成成
        <button>切换</button>
      </div>
      <div
        v-for="(infor, index) in list"
        :key="index"
        class="list"
        @click="select(index)"
      >
        <van-cell :value="infor.main" is-link>
          <template #title>
            <span class="custom-title">{{ infor.title }}</span>
          </template>
        </van-cell>
      </div>
    </div>
    <div class="footer">
      <van-button type="info" :round="true" size="small" @click="confirm"
        >预约体检</van-button
      >
    </div>
    <!-- 底部弹出层 -->
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    <!-- 日期 -->
    <van-calendar v-model="timeShow" @confirm="onConfirm" />
  </div>
</template>

<script>
export default {
  name: 'preventionIndex',
  data() {
    return {
      timeShow: false,
      show: false,
      actions: [],
      list: [
        {
          title: '科室：',
          main: this.$route.params.returnData
            ? this.$route.params.returnData.text
            : '请选择科室'
        },
        {
          title: '性别：',
          main: '请选择性别'
        },
        {
          title: '套餐：',
          main: '请选择套餐'
        },
        {
          title: '预约日期：',
          main: '请选择预约日期'
        }
      ],
      updata: {
        value: '',
        department: '',
        age: '',
        SetMeal: '',
        time: ''
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    select(v) {
      this.updata.value = v
      switch (v) {
        case 0:
          this.$router.push({
            name: 'selectDepartment',
            params: { returnPack: this.$route.name }
          })
          break
        case 1:
          this.show = true
          let ageList = [{ name: '男' }, { name: '女' }]
          this.actions = ageList
          break
        case 2:
          this.show = true
          let mealList = [{ name: '套餐一' }, { name: '套餐二' }]
          this.actions = mealList
          break
        case 3:
          this.timeShow = true
          break
      }
    },
    onSelect(item) {
      this.show = false
      this.uodata = item.name
      this.list[this.updata.value].main = item.name
      if (this.updata.value == 1) {
        this.updata.age = item.name
      } else if (this.updata.value == 2) {
        this.updata.SetMeal = item.name
      }
    },
    onConfirm(date) {
      this.timeShow = false
      let time = `${date.getFullYear()}-${date.getMonth() +
        1}-${date.getDate()}`
      this.updata.time = this.list[this.updata.value].main = time
    },
    onClickLeft() {},
    confirm() {
      this.$router.push('confirmData')
    }
  }
}
</script>

<style scoped>
.information {
  color: #ffffff;
  background-color: rgb(8, 112, 253);
  padding: 7px 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.information button {
  background-color: #ffffff;
  font-size: 18px;
  color: rgb(79, 188, 251);
  border: 1px solid rgb(8, 112, 253);
  border-radius: 20px;
}
.list {
  border-bottom: 1px solid #ebedf0;
}
.footer {
  width: 100vw;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  background-color: #ffffff;
}
.footer button {
  width: calc(100% - 40px);
  margin: 10px 20px 10px 20px;
}
</style>
